import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../profile/styles.css';

export default function ProfileArtistHelpSupportSubscriptionsPage() {
  const t = useTranslations('artist_help.support_subscriptions');
  const [openSections, setOpenSections] = useState({
    support: false,
    howSupportWorks: false,
    whatSupportHelpsYouDo: false,
    communityAccess: false,
    howToSetItUp: false,
    bestPractice: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('support')}
            aria-expanded={openSections.support}
          >
            <h2>{t('sections.support.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.support ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.support && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.support.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('howSupportWorks')}
            aria-expanded={openSections.howSupportWorks}
          >
            <h2>{t('sections.how_support_works.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.howSupportWorks ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.howSupportWorks && (
            <div className="artist-help-category__accordion-content">
              <ul>
                <li>{t('sections.how_support_works.list_1')}</li>
                <li>{t('sections.how_support_works.list_2')}</li>
                <li>{t('sections.how_support_works.list_3')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('whatSupportHelpsYouDo')}
            aria-expanded={openSections.whatSupportHelpsYouDo}
          >
            <h2>{t('sections.what_support_helps_you_do.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.whatSupportHelpsYouDo ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whatSupportHelpsYouDo && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.what_support_helps_you_do.p1')}</p>
              <ul>
                <li>{t('sections.what_support_helps_you_do.list_1')}</li>
                <li>{t('sections.what_support_helps_you_do.list_2')}</li>
                <li>{t('sections.what_support_helps_you_do.list_3')}</li>
                <li>{t('sections.what_support_helps_you_do.list_4')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('communityAccess')}
            aria-expanded={openSections.communityAccess}
          >
            <h2>{t('sections.community_access.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.communityAccess ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.communityAccess && (
            <div className="artist-help-category__accordion-content">
              <ul>
                <li>{t('sections.community_access.list_1')}</li>
                <li>{t('sections.community_access.list_2')}</li>
                <li>{t('sections.community_access.list_3')}</li>
                <li>{t('sections.community_access.list_4')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('howToSetItUp')}
            aria-expanded={openSections.howToSetItUp}
          >
            <h2>{t('sections.how_to_set_it_up.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.howToSetItUp ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.howToSetItUp && (
            <div className="artist-help-category__accordion-content">
              <ul>
                <li>{t('sections.how_to_set_it_up.list_1')}</li>
                <li>{t('sections.how_to_set_it_up.list_2')}</li>
                <li>{t('sections.how_to_set_it_up.list_3')}</li>
                <li>{t('sections.how_to_set_it_up.list_4')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('bestPractice')}
            aria-expanded={openSections.bestPractice}
          >
            <h2>{t('sections.best_practice.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.bestPractice ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.bestPractice && (
            <div className="artist-help-category__accordion-content">
              <div className="artist-help-category__note">
                <p>{t('sections.best_practice.p1')}</p>
              </div>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
